var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7397 1.76524L3.77322 8.17467C1.93236 9.25057 0.800781 11.2226 0.800781 13.3548V26.1291C0.800781 28.2613 1.93236 30.2333 3.77322 31.3092L14.7397 37.7186C16.6062 38.8095 18.9152 38.8119 20.784 37.7249L31.8175 31.3072C33.6645 30.2329 34.8008 28.2574 34.8008 26.1207V13.3631C34.8008 11.2265 33.6645 9.25099 31.8175 8.17669L20.784 1.75894C18.9152 0.671947 16.6062 0.674357 14.7397 1.76524Z",
    fill: "white",
    stroke: "#ECE9F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0113 4.05456L6.02337 9.34616C4.19184 10.4245 3.06744 12.3912 3.06744 14.5166V25.15C3.06744 27.2754 4.19184 29.2422 6.02336 30.3205L15.0113 35.6121C16.8861 36.7159 19.2115 36.7183 21.0886 35.6185L30.134 30.3185C31.9717 29.2418 33.1008 27.2716 33.1008 25.1417V14.525C33.1008 12.3951 31.9717 10.4249 30.134 9.34814L21.0886 4.04819C19.2115 2.94834 16.8861 2.95078 15.0113 4.05456Z",
    fill: "#442B8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1045 6.44551L8.37773 10.4328C6.55489 11.5133 5.43716 13.4752 5.43716 15.5942V23.7119C5.43716 25.8309 6.55489 27.7927 8.37773 28.8732L15.1045 32.8605C16.987 33.9764 19.3277 33.9789 21.2125 32.867L27.9857 28.8713C29.8147 27.7924 30.9372 25.827 30.9372 23.7035V15.6026C30.9372 13.479 29.8147 11.5137 27.9857 10.4348L21.2125 6.43909C19.3277 5.3272 16.987 5.32966 15.1045 6.44551Z",
    fill: "#7B63BF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_52_111",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 26,
    height: 29
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1045 6.44551L8.37773 10.4328C6.55489 11.5133 5.43716 13.4752 5.43716 15.5942V23.7119C5.43716 25.8309 6.55489 27.7927 8.37773 28.8732L15.1045 32.8605C16.987 33.9764 19.3277 33.9789 21.2125 32.867L27.9857 28.8713C29.8147 27.7924 30.9372 25.827 30.9372 23.7035V15.6026C30.9372 13.479 29.8147 11.5137 27.9857 10.4348L21.2125 6.43909C19.3277 5.3272 16.987 5.32966 15.1045 6.44551Z",
    fill: "#FFC100"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_52_111)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.43716,
    y: 5.40909,
    width: 12.3636,
    height: 28.5909,
    fill: "#7B63BF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseMedal);
export default __webpack_public_path__ + "static/media/course-medal.2ac27383fb4ab073004b43505b2e9685.svg";
export { ForwardRef as ReactComponent };